(() => {
  'use strict';
  const $ = (selector, context=document) => context.querySelector(selector);
  const $$ = (selector, context=document) => [...context.querySelectorAll(selector)];
  const config = window.TapBoostConfig || {root:'/', cart:'/cart',currency:'EUR'};
  const root = (config.root || '/').replace(/\/?$/, '/');
  const cartUrl = path => root + path;
  const money = (amount, currency) => {
    const code = currency || config.currency || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: code }).format(amount / 100); }
    catch { return (amount / 100).toFixed(2) + ' ' + code; }
  };
  const esc = value => String(value == null ? '' : value).replace(/[&<>"']/g, x => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[x]));
  const safeUrl = (url, fallback='#') => { try { let parsed = new URL(url, location.origin); return ['http:','https:'].includes(parsed.protocol) ? parsed.href : fallback; } catch { return fallback; } };
  const backdrop = $('[data-cart-backdrop]'), drawer = $('[data-cart-drawer]');
  const toast = $('[data-cart-toast]');
  let previousFocus = null;

  const searchToggle = $('[data-search-toggle]');
  const searchForm = $('#tapboost-search');
  if (searchToggle && searchForm) searchToggle.addEventListener('click', () => {
    const opening = searchForm.hasAttribute('hidden');
    searchForm.toggleAttribute('hidden', !opening);
    searchToggle.setAttribute('aria-expanded', String(opening));
    if (opening) $('input[type=search]', searchForm)?.focus();
  });
  const menuToggle = $('[data-menu-toggle]');
  const mobileNav = $('#tapboost-mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const open = mobileNav.hasAttribute('hidden');
      mobileNav.toggleAttribute('hidden', !open);
      menuToggle.setAttribute('aria-expanded', String(open));
    });
    $$('a',mobileNav).forEach(el => el.addEventListener('click', () => {mobileNav.hidden = true;menuToggle.setAttribute('aria-expanded','false');}));
  }
  function alertUser(message){ if(!toast) return; toast.textContent=message; toast.hidden=false; clearTimeout(alertUser.timer); alertUser.timer=setTimeout(()=>toast.hidden=true,4200); }
  function openDrawer(){
    if (!drawer || !backdrop) {location.href=config.cart; return;}
    previousFocus=document.activeElement;
    drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');backdrop.hidden=false;
    document.body.classList.add('drawer-open');$('[data-cart-close]')?.focus();
    loadCart().catch(()=>{const body=$('[data-drawer-items]');if(body)body.textContent='Could not load your cart. Please open the cart page.';});
  }
  function closeDrawer(){
    drawer?.classList.remove('is-open');drawer?.setAttribute('aria-hidden','true');
    if (backdrop) backdrop.hidden=true;
    document.body.classList.remove('drawer-open');previousFocus?.focus?.();
  }
  $$('[data-cart-open]').forEach(el=>el.addEventListener('click',openDrawer));
  $('[data-cart-close]')?.addEventListener('click',closeDrawer);
  backdrop?.addEventListener('click',closeDrawer);
  document.addEventListener('keydown',e=>{
    if(e.key==='Escape'){
      if(drawer?.classList.contains('is-open')){closeDrawer();return;}
      if(searchForm && !searchForm.hidden){searchForm.hidden=true;searchToggle?.setAttribute('aria-expanded','false');searchToggle?.focus();}
      if(mobileNav && !mobileNav.hidden){mobileNav.hidden=true;menuToggle?.setAttribute('aria-expanded','false');menuToggle?.focus();}
    }
    if(e.key==='Tab' && drawer?.classList.contains('is-open')){
      const list=$$('a,button,input,select,[tabindex]:not([tabindex="-1"])',drawer).filter(el=>!el.disabled && el.offsetParent!==null);
      if(!list.length)return;
      if(e.shiftKey && document.activeElement===list[0]){list[list.length-1].focus();e.preventDefault();}
      if(!e.shiftKey && document.activeElement===list[list.length-1]){list[0].focus();e.preventDefault();}
    }
  });

  async function loadCart(){
    const res=await fetch(cartUrl('cart.js'),{credentials:'same-origin'});
    if(!res.ok) throw new Error('Cart could not be loaded');
    const cart=await res.json();renderCart(cart);return cart;
  }
  function renderCart(cart){
    $$('[data-cart-count]').forEach(el=>{el.textContent=cart.item_count;el.hidden = cart.item_count===0;});
    const count=$('[data-drawer-count]');if(count) count.textContent=`(${cart.item_count})`;
    const subtotal=$('[data-drawer-subtotal]');if(subtotal)subtotal.textContent=money(cart.total_price, cart.currency);
    const body=$('[data-drawer-items]');if(!body)return;
    if(!cart.items.length){body.innerHTML='<div class="drawer-empty"><span>◌</span><h3>Your bag is empty</h3><p>Discover simple NFC tools for your business.</p><a href="'+esc(config.cart)+'">View your bag</a></div>';return;}
    body.innerHTML=cart.items.map((item,i)=>{
      const image=item.image ? `<img src="${esc(safeUrl(item.image))}" alt="" loading="lazy">` : '<span class="drawer-no-image">NFC</span>';
      return `<div class="drawer-line"><a class="drawer-line-image" href="${esc(safeUrl(item.url))}">${image}</a><div class="drawer-line-info"><a class="drawer-item-title" href="${esc(safeUrl(item.url))}">${esc(item.product_title)}</a>${item.variant_title && item.variant_title!=='Default Title'?`<span class="drawer-variant">${esc(item.variant_title)}</span>`:''}<strong>${esc(money(item.final_line_price,cart.currency))}</strong><div class="drawer-quantity"><button type="button" data-cart-change data-line="${i+1}" data-qty="${item.quantity-1}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change data-line="${i+1}" data-qty="${item.quantity+1}" aria-label="Increase quantity">+</button></div></div><button type="button" class="drawer-remove" data-cart-change data-line="${i+1}" data-qty="0" aria-label="Remove ${esc(item.product_title)}">×</button></div>`;
    }).join('');
    $$('[data-cart-change]',body).forEach(button=>button.addEventListener('click',async ()=>{
      if(button.disabled)return;button.disabled=true;
      try{
        const res=await fetch(cartUrl('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({line:Number(button.dataset.line),quantity:Number(button.dataset.qty)})});
        const data=await res.json();if(!res.ok)throw new Error(data.description||'Unable to update the cart');renderCart(data);
      }catch(error){alertUser(error.message||'Unable to update your bag');button.disabled=false;}
    }));
  }
  $$('form.product-buy-form, form.product-quick-cart, form.catalog-quick-form').forEach(form=>{
    form.addEventListener('submit',async event=>{
      const submitter=event.submitter;
      const direct=Boolean(submitter?.matches('[data-direct-checkout]'));
      if(submitter && !submitter.matches('.buy-button, .quick-cart-button, .catalog-add, [data-direct-checkout]'))return;
      event.preventDefault();
      const button=submitter||$('button[type=submit]',form),err=$('[data-product-error]',form);
      if(!button||button.disabled)return;
      button.disabled=true;button.classList.add('is-working');button.setAttribute('aria-busy','true');
      if(err)err.hidden=true;
      try{
        const data=new FormData(form);
        const response=await fetch(cartUrl('cart/add.js'),{method:'POST',body:data,headers:{'Accept':'application/json'},credentials:'same-origin'});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||result.message||'Could not add this item');
        if(direct){location.assign('/checkout');return;}
        openDrawer();
      }catch(error){
        if(err){err.textContent=error.message||'Unable to add this item';err.hidden=false;}
        else alertUser(error.message||'Something went wrong adding this product.');
      }finally{button.disabled=false;button.classList.remove('is-working');button.removeAttribute('aria-busy');}
    });
  });
  $$('[data-gallery-thumb]').forEach(button=>button.addEventListener('click',()=>{
    const gallery=button.closest('[data-gallery]'), image=$('.pdp-active-image',gallery);
    if(image){image.src=button.dataset.fullSrc;image.srcset='';image.alt=button.dataset.alt||'';}
    $$('[data-gallery-thumb]',gallery).forEach(b=>{b.classList.toggle('is-selected', b===button);b.setAttribute('aria-pressed',String(b===button));});
  }));
  const variantSelect=$('[data-variant-selector]');
  if(variantSelect){
    let variants=[];
    try {variants=JSON.parse($('script[id^="ProductVariants-"]')?.textContent||'[]');}catch{}
    const updateVariant=()=>{
      const variant=variants.find(v=>String(v.id)===variantSelect.value);if(!variant)return;
      const price=$('[data-pdp-price]'), compare=$('[data-pdp-compare]'), availability=$('[data-availability]'), add=$('.product-buy-form .buy-button');
      const currency=config.currency||'EUR';
      if(price)price.textContent=money(variant.price,currency);
      if(compare){compare.hidden=!(variant.compare_at_price>variant.price);if(!compare.hidden)compare.textContent=money(variant.compare_at_price,currency);}
      if(availability)availability.textContent=variant.available?'Available to order':'Currently unavailable';
      if(add){add.disabled=!variant.available;const text=$('[data-add-label]',add);if(text)text.textContent=variant.available?'Add to cart':'Sold out';}
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(null,'',url);
    };
    const colourPicker=$('[data-nfc-colour-picker]');
    if(colourPicker){
      const position=Number(colourPicker.dataset.optionPosition)-1;
      const swatches=$$('[data-nfc-colour]',colourPicker);
      const syncSwatches=()=>{
        const selected=variants.find(v=>String(v.id)===variantSelect.value);
        const colour=selected?.options?.[position]||'';
        swatches.forEach(b=>{const active=b.dataset.nfcColour===colour;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active));});
        const label=$('[data-selected-colour]',colourPicker);if(label)label.textContent=colour;
        const image=$('.pdp-active-image');
        const src=selected?.featured_image?.src || selected?.featured_media?.preview_image?.src;
        if(src && image){image.src=src;image.srcset='';image.alt=selected.featured_image?.alt||document.title;}
      };
      swatches.forEach(button=>button.addEventListener('click',()=>{
        const colour=button.dataset.nfcColour;
        const current=variants.find(v=>String(v.id)===variantSelect.value);
        const match=variants.find(v=>v.available&&v.options?.[position]===colour&&(!current||v.options.every((o,i)=>i===position||o===current.options[i])))||variants.find(v=>v.available&&v.options?.[position]===colour);
        if(!match){alertUser('This colour is currently unavailable');return;}
        variantSelect.value=String(match.id);
        variantSelect.dispatchEvent(new Event('change',{bubbles:true}));
      }));
      variantSelect.addEventListener('change',syncSwatches);
      syncSwatches();
    }
    variantSelect.addEventListener('change',updateVariant);
  }
})();
